import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { guardString } from "@msuite/utils/strings";
import type { AutoIntegrationListItem, PersonioPerson } from "@msuite/utils/types";
import { IntegrationState } from "./integration-state";
import { RowActions } from "./row-actions";

export const columnHelper = createColumnHelper<AutoIntegrationListItem<PersonioPerson>>();

export const columns = [
	columnHelper.accessor("state", {
		id: "integration-state",
		header: localized("integrations.state"),
		cell: (cell) => <IntegrationState state={cell.getValue()} />,
	}),
	columnHelper.accessor(
		(row) => {
			return row.state !== "external" ? row.internalName : guardString(null);
		},
		{
			id: "internal-name",
			header: localized("integrations.internal"),
			cell: (cell) => cell.getValue(),
		},
	),
	columnHelper.accessor(
		(row) => {
			return row.externalName;
		},
		{
			id: "external-name",
			header: localized("integrations.external"),
			cell: (cell) => cell.getValue(),
		},
	),
	columnHelper.accessor("externalId", {
		id: "external-id",
		header: localized("integrations.external"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor((row) => row.externalMisc, {
		id: "external-misc",
		header: localized("misc.misc"),
		cell: (cell) => cell.getValue(),
	}),
	createRowActions(RowActions),
];
